import React, { useContext, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import styles from "./checkoutpage.module.css";
import HomePageHeader from "./../../components/HomePageHeader";
import HomePageFooter from "./../../components/HomePageFooter";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import useSWR from "swr";
import { get } from "../../apis";
import { CartContext } from "../../../src/context/Card_context";
import ImageWithFallback from "../../components/ImageWithFallback";
import { genPaymentUrl } from "../../apis/payment";
import { useCookies } from "react-cookie";
import { Bounce, toast, ToastContainer } from "react-toastify";
import { formatPrice } from "../../utils/product";

export default function CheckoutPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [cookie, setCookie] = useCookies(["access_token"]);

  const [cartItems, setCartItems] = useState(location.state.cartItems);
  const [selectedItems, setSelectedItems] = useState([]);
  const [shipFee, setShipFee] = useState(20000);
  const [paymentType, setPaymentType] = useState("");
  const [currCode, setCurrCode] = useState("VND");
  const [billingAddress, setBillingAddress] = useState("218 Nguyễn Kim, Cẩm Lệ, Đà Nẵng");
  const [promotionCode, setPromotionCode] = useState("");

  const [address, setAddress] = useState(null);
  useEffect(() => {
    const _selectedItems = cartItems.filter((item) => item.selected);
    setSelectedItems(_selectedItems)
    // console.log(location.state);
    // if (!location.state.total) {
    //   navigate("/cart");
    // }
  }, []);

  const handleSave = (newAddress) => {
    setAddress(newAddress);
  };

  const handleCancel = () => {
    setAddress(null);
  };

  const handleFAQ = () => {
    navigate("/faq");
  };

  const submitCheckout = () => {
    const orderProduct = []

    for(let idx in selectedItems){
      const selectedItem = selectedItems[idx]
      orderProduct.push({
        "productCode": selectedItem.productCode,
        "quantity": selectedItem.quantity
      })
    }

    toast.promise(new Promise(async (resolve, reject) => {
      const result = await genPaymentUrl(setPaymentType, currCode, billingAddress, orderProduct, promotionCode, cookie["access_token"])
      if(result.status === 200) window.location.href = result.data.paymentUrl
      else reject(result)
    }), {
      pending: {
        render() {
          return t("payment_url_redirecting");
        },
        position: "top-center",
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        transition: Bounce,
      },
      error: {
        render({ result }) {
          return `${t("error_occurred")}: ${result.response?.result?.message || result.message}`;
        },
      },
    })
  }

  return (
    <div className={styles.background}>
      <ToastContainer />
      <HomePageHeader />
      <div className="container">
        <h1 className={styles.title}>Trang Thanh Toán</h1>
        <div className="card mb-1 shadow">
          <div className="card-header bg-white d-flex justify-content-between align-items-center">
            <h4 className={styles.cardnamestyle}>Địa chỉ nhận hàng</h4>
            <button className={styles.butt}>Thay đổi</button>
          </div>
          <div className="card-body d-flex">
            <p className={`col-3 ${styles.name_phone}`}>
              Nguyen Duy Anh
              <br />
              (+84)364246155
            </p>
            <p className="col-8">
              Xoãn Store, An Bình City, Khu Đô Thị Thành Phố Giao Lưu, Xã Côn
              Đảo, Huyện Côn Đảo, Bà Rịa - Vũng Tàu
            </p>
          </div>
        </div>
        <div className="card mb-1">
          <div className="card-header d-flex align-items-start px-3 border-bottom">
            <div className="col-6 px-3 align-items-start font-weight-bold">
              {t("products")}
            </div>
            <div className="col-2 text-center font-weight-bold">
              {t("price")}
            </div>
            <div className="col-2 text-center font-weight-bold">
              {t("quantity")}
            </div>
            <div className="col-2 text-center font-weight-bold">
              {t("total")}
            </div>
          </div>
          <div className="card-body">
            {selectedItems.length > 0 ? (
              selectedItems.map((item, index) => (
                <div
                  key={index}
                  className="d-flex align-items-start p-3 border-bottom"
                >
                  <div className="col-2">
                    <ImageWithFallback src={item.productImage} alt={item.productAlt} />
                  </div>
                  <div className="col-4">
                    <a href={item.productLink}>{item.productTitle}</a>
                    <div>{item.shopName}</div>
                    <div>{item.categoryDetails}</div>
                  </div>
                  <div className="col-2 text-center">
                    {formatPrice(item.price)}
                  </div>
                  <div className="col-2 text-center">{item.quantity}</div>
                  <div className="col-2 text-center">
                    {formatPrice(item.totalPrice)}
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center">
                <h2>{t("no_items_selected_for_checkout")}</h2>
              </div>
            )}

            <input
              type="text"
              className="form-control mt-3"
              placeholder="Nhập mã giảm giá của shop"
            />
          </div>
        </div>
        <div className="card mb-1">
          <div className="card-header bg-white d-flex justify-content-between align-items-center">
            <h5 className={styles.cardnamestyle}>Đơn vị vận chuyển</h5>
            <button className={styles.butt}>Thay đổi</button>
          </div>
          <div className="card-body">
            <div className="d-flex align-items-center justify-content-between">
              <p className={styles.shipping_type}>Vận chuyển Nhanh</p>
              <p>Phí vận chuyển: 20.000 đ</p>
            </div>
            <p className="text-secondary">
              Đảm bảo đơn hàng được giao trong ngày 17-7-2024
            </p>
            <p className="text-secondary">
              Nếu đơn hàng được giao sau ngày 17-7-2024 bạn sẽ nhận mã giảm giá
              trị giá 15.000 đ
            </p>
          </div>
        </div>
        <div className="card mb-1">
          <div className="card-header bg-white d-flex justify-content-between align-items-center">
            <h5 className={styles.cardnamestyle}>BHive Voucher</h5>
            <button className={styles.butt}>Chọn Voucher</button>
          </div>
          <div className="card-body d-flex justify-content-end">
            <p>0 đ</p>
          </div>
        </div>
        <div className="card">
          <div className="card-header bg-white d-flex justify-content-between align-items-center">
            <h5 className={styles.cardnamestyle}>Phương thức thanh toán</h5>
            <button className={styles.butt}>Thay đổi</button>
          </div>
          <div className="card-body">
            <p className={styles.payment_type}>Thanh toán khi nhận hàng</p>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between">
              <div className="col-6"></div>
              <p>Tổng tiền hàng:</p>
              <p>{formatPrice(Object.values(selectedItems).reduce((total, value) => total + value.totalPrice, 0))}</p>
            </div>
            <div className="d-flex justify-content-between">
              <div className="col-6"></div>
              <p>Phí vận chuyển:</p>
              <p>{formatPrice(shipFee)}</p>
            </div>
            <div className="d-flex justify-content-between">
              <div className="col-6"></div>
              <p>Giảm giá shop:</p>
              <p>0 đ</p>
            </div>
            <div className="d-flex justify-content-between">
              <div className="col-6"></div>
              <p>BHive Voucher:</p>
              <p>0 đ</p>
            </div>
            <div className="d-flex justify-content-between">
              <div className="col-6"></div>
              <h4>Tổng thanh toán:</h4>
              <h4>{formatPrice(Object.values(selectedItems).reduce((total, value) => total + value.totalPrice, 0) + shipFee)}</h4>
            </div>
          </div>
        </div>
        <div className="card mb-3">
          <div className="card-body d-flex">
            <div className="col-9 text-secondary">
              Nhấn “Đặt hàng” đồng nghĩa với việc bạn sẽ tuân theo{" "}
              <button
                className="text-primary cursor-pointer bg-transparent border-0"
                onClick={handleFAQ}
              >
                Điều khoản BHive{" "}
              </button>
            </div>
            <button className={styles.order_butt} onClick={submitCheckout}>{t("order_product")}</button>
          </div>
        </div>
      </div>
      <HomePageFooter />
    </div>
  );
}
